import { render, staticRenderFns } from "./UserConfigAdd.vue?vue&type=template&id=c94891e4&scoped=true"
import script from "./UserConfigAdd.vue?vue&type=script&lang=js"
export * from "./UserConfigAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94891e4",
  null
  
)

export default component.exports